var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBiport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 297,
    viewBox: "0 0 343 297",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.692 170.776C311.725 165.943 318.392 159.999 323.59 153.018C331.164 142.864 335 130.935 335 117.558C335 99.08 327.439 84.5968 312.517 74.4979C298.37 64.9413 277.812 60.0909 251.412 60.0909H205.434L202.88 72.7992H251.412C275.206 72.7992 293.351 76.9083 305.339 85.0119C316.702 92.7004 322.228 103.346 322.228 117.558C322.228 128.296 319.32 137.417 313.334 145.448C307.285 153.569 298.651 160.029 287.676 164.655C285.334 165.638 283.802 167.912 283.78 170.446C283.755 172.979 285.245 175.279 287.569 176.308C295.697 179.905 302.01 184.802 306.335 190.859C310.614 196.858 312.696 203.911 312.696 212.43C312.696 232.894 304.488 247.839 287.599 258.12C269.953 268.871 246.704 274.323 218.504 274.323H162.372L159.817 287.032H218.504C249.092 287.032 274.585 280.953 294.266 268.96C314.969 256.358 325.468 237.338 325.468 212.43C325.468 201.344 322.534 191.609 316.749 183.501C313.279 178.638 308.911 174.385 303.692 170.776Z",
    fill: "black",
    fillOpacity: 0.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.046 229.033C250.153 224.541 253.379 217.84 253.379 209.659C253.379 203.222 250.711 197.919 245.666 194.314C241.178 191.114 235.612 189.487 229.13 189.487H179.098L176.541 202.035H229.13C232.91 202.035 235.859 202.825 238.144 204.46C239.354 205.326 240.594 206.619 240.594 209.659C240.594 215.243 238.186 217.661 236.375 218.995C233.013 221.471 228.295 222.726 222.354 222.726H172.327L169.77 235.273H222.354C231.125 235.273 238.421 233.174 244.046 229.033Z",
    fill: "black",
    fillOpacity: 0.08
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.363 131.037C257.363 124.759 254.755 119.652 249.811 116.253C245.473 113.287 239.772 111.849 232.375 111.849H194.486L191.979 124.347H232.375C237.022 124.347 240.6 125.109 242.71 126.555C243.805 127.309 244.825 128.371 244.825 131.037C244.825 135.27 244.825 143.147 227.544 143.147H188.205L185.697 155.645H227.544C253.489 155.645 257.363 140.227 257.363 131.037Z",
    fill: "black",
    fillOpacity: 0.08
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.868 60.0909L123.983 287.032H136.834L181.714 60.0909H168.868Z",
    fill: "black",
    fillOpacity: 0.08
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.007 60.0909L94.123 287.032H106.974L151.854 60.0909H139.007Z",
    fill: "black",
    fillOpacity: 0.08
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.003 60.0909H107.157L62.2725 287.032H75.1229L120.003 60.0909Z",
    fill: "black",
    fillOpacity: 0.08
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_44_233)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.419 145.685C284.453 140.852 291.12 134.908 296.318 127.927C303.891 117.773 307.727 105.845 307.727 92.4669C307.727 73.9891 300.166 59.5058 285.245 49.407C271.098 39.8503 250.539 35 224.14 35H178.162L175.607 47.7083H224.14C247.934 47.7083 266.078 51.8173 278.067 59.921C289.429 67.6095 294.955 78.2548 294.955 92.4669C294.955 103.205 292.048 112.326 286.062 120.357C280.012 128.478 271.379 134.938 260.403 139.564C258.062 140.547 256.529 142.821 256.508 145.355C256.482 147.888 257.972 150.188 260.297 151.217C268.424 154.814 274.738 159.711 279.063 165.768C283.342 171.767 285.423 178.82 285.423 187.339C285.423 207.803 277.215 222.748 260.327 233.029C242.68 243.78 219.431 249.232 191.231 249.232H135.099L132.545 261.941H191.231C221.82 261.941 247.312 255.862 266.994 243.869C287.697 231.267 298.195 212.247 298.195 187.339C298.195 176.253 295.262 166.518 289.476 158.41C286.007 153.547 281.639 149.294 276.419 145.685Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.774 203.942C222.881 199.45 226.107 192.749 226.107 184.568C226.107 178.131 223.439 172.828 218.393 169.223C213.906 166.023 208.34 164.396 201.858 164.396H151.826L149.269 176.944H201.858C205.638 176.944 208.587 177.734 210.871 179.369C212.082 180.235 213.322 181.528 213.322 184.568C213.322 190.152 210.914 192.57 209.103 193.904C205.74 196.38 201.023 197.635 195.082 197.635H145.054L142.497 210.182H195.082C203.852 210.182 211.148 208.083 216.774 203.942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.09 105.946C230.09 99.6684 227.482 94.5611 222.538 91.1617C218.2 88.1956 212.5 86.7584 205.103 86.7584H167.214L164.706 99.256H205.103C209.75 99.256 213.327 100.018 215.438 101.464C216.533 102.218 217.553 103.28 217.553 105.946C217.553 110.179 217.553 118.056 200.271 118.056H160.932L158.425 130.554H200.271C226.216 130.554 230.09 115.136 230.09 105.946Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.595 35L96.7109 261.941H109.561L154.441 35H141.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.735 35L66.8506 261.941H79.7011L124.581 35H111.735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.7305 35H79.8842L35 261.941H47.8505L92.7305 35Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_44_233",
    x: 0,
    y: 0,
    width: 342.728,
    height: 296.941,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_44_233"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_44_233",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiport);
export default __webpack_public_path__ + "static/media/biport.bb20db5646e73fddd58aa8061daf839c.svg";
export { ForwardRef as ReactComponent };